import React, { Fragment, PropsWithChildren, ReactElement } from 'react';

import { TSvgIcon } from './svg.types';
import { StyledSvg } from './svg.styled';

export function Svg({
    children,
    color = 'purple',
    width = 24,
    height = 24,
    preserveAspectRatio = 'none',
    viewBox = '0 0 24 24',
    accessibleDescription,
    accessibleDescriptionElementId,
    accessibleTitle,
    accessibleTitleElementId,
    style,
    testID,
    ...otherProperties
}: PropsWithChildren<TSvgIcon>): ReactElement {
    const ariaLabelledByParts = [];

    if (accessibleDescription && accessibleDescriptionElementId) {
        ariaLabelledByParts.push(accessibleDescriptionElementId);
    } else if (accessibleTitle && accessibleTitleElementId) {
        ariaLabelledByParts.push(accessibleTitleElementId);
    }

    const ariaLabelledBy =
        ariaLabelledByParts.length > 0
            ? {
                  'aria-labelledby': ariaLabelledByParts.join(' '),
              }
            : {};

    return (
        <StyledSvg
            xmlns="http://www.w3.org/2000/svg"
            width={width}
            height={height}
            viewBox={viewBox}
            preserveAspectRatio={preserveAspectRatio}
            aria-hidden={accessibleTitle ? 'false' : 'true'}
            style={style && style}
            fillColor={color}
            data-testid={testID && testID}
            role="img"
            {...ariaLabelledBy}
            {...otherProperties}
        >
            <Fragment>
                {accessibleTitle && (
                    <title
                        id={
                            accessibleTitleElementId && accessibleTitleElementId
                        }
                    >
                        {accessibleTitle}
                    </title>
                )}
                {children && children}
                {accessibleDescription && (
                    <desc
                        id={
                            accessibleDescriptionElementId &&
                            accessibleDescriptionElementId
                        }
                    >
                        {accessibleDescription}
                    </desc>
                )}
            </Fragment>
        </StyledSvg>
    );
}
